// contactUtils.js

import { contactLevelMap } from '../config/contactFormDataConfig';

// Convert contactLevelMap array to an object for easy lookup
const contactLevelMapObj = contactLevelMap.reduce((acc, item) => {
  acc[item.key] = item.value;
  return acc;
}, {});

export const getContactLevelName = (value) => {
  return contactLevelMapObj[value] || 'N/A';
};
